import { Pipe, PipeTransform } from '@angular/core';
import Utils from '@shared/utils/utils';

@Pipe({ name: 'telNoCountry' })
export class TelNoCountryPipe implements PipeTransform {

  transform(tel: any): any {
    return Utils.telWithoutCountry(tel);
  }

}
